import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-durg-divisional-chess-tournament',
  templateUrl: './durg-divisional-chess-tournament.component.html',
  styleUrls: ['./durg-divisional-chess-tournament.component.scss']
})
export class DurgDivisionalChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
